<template>
  <!-- 這邊注意要有 direction="vertical"，因為el-header非第一層子元素 -->
  <el-container direction="vertical" :class="classes">
    <component
      :is="headerComponent"
      ref="header"
      :agent="agent"
      :member="member"
      :user="user"
      :marquee="marquee"
      :type="type"
      :site="site"
      @on-bars-click="handleBarsClick"
      @on-logout="handleLogout"
      @on-profile="handleProfileClick"
    >
      <slot name="title">{{ $t("component.header.title") }}</slot>
      <template v-slot:tools>
        <portal-target
          name="tools"
          multiple
          class="el-row is-justify-center is-align-middle el-row--flex"
        ></portal-target>
      </template>
    </component>
    <el-container ref="container" style="height: calc(100vh - 108px)">
      <tg-menu class="tg-app--menu"></tg-menu>
      <el-container :class="$route.name">
        <el-header
          v-if="$route.name != 'notOpen'"
          class="tg-app--breadcrumb"
          height="25"
        >
          <tg-breadcrumb></tg-breadcrumb>
          <el-divider></el-divider>
        </el-header>
        <el-main class="tg-app--container">
          <slot></slot>
        </el-main>
      </el-container>
    </el-container>
  </el-container>
</template>

<script>
import TgHeader from "@/components/header/TgHeader";
import DarkPurpleHeader from "@/components/header/DarkPurpleHeader";
import LightHeader from "@/components/header/LightHeader";
import TgMenu from "@/components/navigation/TgMenu";
import TgBreadcrumb from "@/components/breadcrumb/TgBreadcrumb";

import { mapState } from "vuex";
import formatter from "@/utils/formatter";
export default {
  components: {
    TgHeader,
    TgMenu,
    TgBreadcrumb,
    DarkPurpleHeader,
    LightHeader,
  },
  computed: {
    headerComponent() {
      switch (this.$theme) {
        case "dark-purple":
          return "dark-purple-header";
        default:
          return "light-header";
      }
    },
    classes() {
      return [
        "tg-app",
        {
          "is-floating": this.floating,
          "has-extension": !!this.$scopedSlots.extension,
        },
      ];
    },
    containerClass() {
      return ["tg-app--container"];
    },
    currentTitle() {
      let meta = this.$route.meta;

      if (meta.title) {
        return meta.title;
      }

      if (meta && meta.parent && meta.parent.title) {
        return meta.parent.title;
      }

      return "";
    },
    ...mapState("app", {
      marquee: (state) => state.marquee,
      agent: (state) => formatter.thousand(state.onlineAgent),
      member: (state) => formatter.thousand(state.onlineMember),
      user: (state) => state.user,
    }),
    type() {
      return "main";
    },
    floating() {
      return this.$route.meta && this.$route.meta.floating && this.isMobile;
    },
    site() {
      return this.$store.state.app.site;
    },
  },
  methods: {
    handleBarsClick() {
      this.$store.commit("app/TOGGLE_MENU_COLLAPSE");
    },
    parseContainerHeight() {
      let height =
        document.documentElement.clientHeight -
        this.$refs.container.$el.offsetTop;
      this.$refs.container.$el.style.height = height + "px";
    },
    handleLogout() {
      this.$store.commit("breadcrumb/clear");
      this.$router.push({ name: "login" });
    },
    handleProfileClick() {
      if (this.$route.name == "member.profile") {
        return;
      }
      this.$router.push({ name: "member.profile" });
    },
  },
  mounted() {
    // this.parseContainerHeight();
    // window.addEventListener("resize", () => {
    //   this.parseContainerHeight();
    // });
  },
};
</script>
